// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'

Vue.config.productionTip = false

import iView from 'iview';
import 'iview/dist/styles/iview.css';
Vue.use(iView);

import { Table,TableColumn } from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.component(Table.name, Table);
Vue.component(TableColumn.name, TableColumn);

import storage from '@/utils/storage.js';
Vue.prototype.$storage=storage;

import axios from 'axios';
import qs from 'qs';
Vue.prototype.$qs=qs;
Vue.prototype.$axios=axios;

import '@/assets/layui.css'

//验证登陆信息
router.beforeEach((to, from, next) => {
  if(to.path=='/login'){
    next();
  }else{
    let uid = storage.getSession('uid');
    if(uid){
      next();
    }else{
      router.push({path:'/login'});
    }
  }
});



// 请求拦截器
axios.interceptors.request.use(function (config) {
  const token = storage.getSession('token'); // 从localStorage中获取token
  if (token) {
    config.headers.Authorization = `Bearer ${token}`; // 将token添加到Authorization头部
  }
  return config;
}, function (error) {
  return Promise.reject(error);
});

axios.interceptors.response.use(function(response){
  try {
    if(response.data.code===403||response.data.code==='403'){
      Vue.prototype.$Notice.error({
        title: '异常信息',
        desc: response.data.msg,
        duration: 0
      });
      router.push({path:'/login'});
    }
  }catch (e) {
  }
  // 请求成功处理回调
  return response;
}, function(error){
  //请问这里如何判断error的状态码，以便根据不同的状态码做出不同的提示

  if (error.response) {
    // 可以访问错误响应的状态码和其他信息
    const statusCode = error.response.status;

    if (statusCode === 401) {
      // 处理 401 错误，例如跳转到登录页面
      Vue.prototype.$Notice.error({
        title: '登录信息已过期',
        desc: '为了数据安全，您的登录信息已过期，请重新登录系统',
        duration: 0
      });
      router.push({ path: '/login' });
    } else {
      console.log(error.request);
      Vue.prototype.$Notice.error({
        title: '请求未发送到服务器或网络异常',
        desc: '请刷新网页或重新登录后重试，如未解决请联系管理员。<br/>错误信息：' + error.request,
        duration: 0
      });
    }
    // 其他状态码的处理...
  } else if (error.request) {
    // 处理请求未发送到服务器的错误，如网络异常
    Vue.prototype.$Notice.error({
      title: '网络异常',
      desc: '您的设备网络异常，请检查您的网络连接。',
      duration: 0
    });
  } else {
    // 其他错误处理...
    console.log(error);
    Vue.prototype.$Notice.error({
      title: '其他错误',
      desc: '请刷新网页或重新登录后重试，如未解决请联系管理员。<br/>错误信息：' + error,
      duration: 0
    });
  }

});

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js